import { AbstractService } from '@uniqoders/sdk';

export default class ActivityCategoryService extends AbstractService {
  /**
   * Retrieve all CMS activity categories for an agency
   */
  public listCmsActivityCategories(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/activity-categories', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS activity category
   */
  public getCmsActivityCategory(agency: string, categoryId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/activity-categories/{categoryId}', { agency, categoryId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS activity category
   */
  public createCmsActivityCategory(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/activity-categories', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS activity category
   */
  public updateCmsActivityCategory(agency: string, categoryId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/activity-categories/{categoryId}', { agency, categoryId }),
      data,
    });
  }

  /**
   * Delete a CMS activity category
   */
  public deleteCmsActivityCategory(agency: string, categoryId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/activity-categories/{categoryId}', { agency, categoryId }),
    });
  }
}

